import { useState, useEffect } from 'react';
import { api } from '../api/client';

/**
 * Fetches SEO metadata for a static page slug from the backend.
 * Returns { seo_title, seo_description, og_image_url, robots, loading }.
 * Falls back to empty values if the backend returns nothing.
 */
export function usePageSeo(slug) {
  const [seo, setSeo] = useState({ seo_title: null, seo_description: null, og_image_url: null, robots: 'index,follow' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) { setLoading(false); return; }
    setLoading(true);
    api(`/api/page-seo/${slug}`)
      .then((data) => setSeo({
        seo_title: data.seo_title || null,
        seo_description: data.seo_description || null,
        og_image_url: data.og_image_url || null,
        robots: data.robots || 'index,follow',
      }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  return { ...seo, loading };
}
